import React from 'react';
import Formulario from "./Formulario";
import Tabela from "./Tabela";
import useRenderFormStore from "../stores/useRenderFormStore";

const ManutencaoApp = () => {

    const {showForm} = useRenderFormStore();

    return (
        showForm ? <Formulario/> : <Tabela/>
    );
};

export default ManutencaoApp;